// Stat Boxes, Stat Size: Small — keep every stat in a group on ONE line (Matt H10, 2026-10-03:
// "Use small so things are on one line"). The whole group shrinks together so the row stays even.
// Never below 18px: past that the group falls back to wrapping.
const MIN_SIZE = 18;

function fitGroup(group) {
  const stats = Array.from(group.querySelectorAll('.statBox-stat'));
  group.style.removeProperty('--stat-fit');
  group.classList.add('statBoxes--fit');
  if (!stats.length) return;
  const base = parseFloat(window.getComputedStyle(stats[0]).fontSize);
  let scale = 1;
  stats.forEach((stat) => {
    if (stat.scrollWidth > stat.clientWidth + 0.5) scale = Math.min(scale, stat.clientWidth / stat.scrollWidth);
  });
  if (scale >= 1) return;
  const size = Math.floor(base * scale * 10) / 10;
  if (size >= MIN_SIZE) group.style.setProperty('--stat-fit', `${size}px`);
  else group.classList.remove('statBoxes--fit');
}

function fitAll() {
  document.querySelectorAll('.statBoxes--small').forEach(fitGroup);
}

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.statBoxes--small')) return;
  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  let frame = null;
  window.addEventListener('resize', () => {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(fitAll);
  }, { passive: true });
});
